import React from 'react';
import { Box, SxProps } from '@mui/material';

interface ButtonContainerProps {
  children: React.ReactNode;
  sx?: SxProps;
}

export function ButtonContainer({ children, sx }: ButtonContainerProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: '16px',
        '& > button, & > div': {
          transition: 'transform 0.2s, box-shadow 0.2s',
          '&:hover': {
            transform: 'scale(1.05)',
            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
          },
        },
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
